'use client';

import { useState } from 'react';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { ScheduledSlotsGrid } from './_components/scheduled-slots-grid.component';
import { ScheduledTabPreview } from './_components/scheduled-tab-preview.component';
import { SearchCardClinicScheduledModal } from './search-card-clinic-scheduled-modal.component';

import { SlotsSkeleton } from '@/app/(main)/(pages)/_components/schedules/slots-skeleton.component';
import { useScheduleSlots } from '@/app/(main)/(pages)/_components/schedules/_hooks/use-schedule-slots.hook';
import { useSlotFilters } from '@/app/(main)/(pages)/busca/[slug]/_hooks/use-slot-filters.hook';
import { ScheduleType, SearchPartnerData } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';

const CARD_SCHEDULED_DAYS = 3;

interface SearchCardClinicTabScheduledProps {
  schedule: SearchPartnerData;
}

export function SearchCardClinicTabScheduled({ schedule }: SearchCardClinicTabScheduledProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const scheduleId = schedule.schedulesTypes[ScheduleType.SCHEDULED]?.[0]?.id;
  const slotFilters = useSlotFilters();

  const { isLoading, days, hasMore, offset, goNext, goPrev } = useScheduleSlots({
    scheduleId,
    limitDays: CARD_SCHEDULED_DAYS,
    filters: slotFilters,
  });

  const openModal = () => setIsModalOpen(true);

  return (
    <div data-testid={DataTestIdEnum.SEARCH_CARD_CLINIC_TAB_SCHEDULED}>
      {isLoading
        ? (
            <>
              <SlotsSkeleton variant="card" className="xl:hidden" />
              <SlotsSkeleton variant="modal" columns={CARD_SCHEDULED_DAYS} className="hidden xl:flex" />
            </>
          )
        : (
            <>
              <ScheduledTabPreview
                day={days[0]}
                className="xl:hidden"
                onSeeMore={openModal}
              />
              <ScheduledSlotsGrid
                days={days}
                hasMore={hasMore}
                offset={offset}
                className="hidden xl:flex"
                onPrev={goPrev}
                onNext={goNext}
                onSeeMore={openModal}
              />
            </>
          )}

      <SearchCardClinicScheduledModal
        scheduleId={scheduleId}
        schedule={schedule}
        open={isModalOpen}
        onOpenChange={setIsModalOpen}
      />
    </div>
  );
}
